// TXDOT District to County Mapping
// Based on official TXDOT district boundaries

export const TXDOT_DISTRICTS = {
  'Amarillo': ['ARMSTRONG', 'BRISCOE', 'CARSON', 'CASTRO', 'CHILDRESS', 'COLLINGSWORTH', 'DALLAM', 'DEAF SMITH', 'DONLEY', 'GRAY', 'HALL', 'HANSFORD', 'HARTLEY', 'HEMPHILL', 'HUTCHINSON', 'LIPSCOMB', 'MOORE', 'OCHILTREE', 'OLDHAM', 'PARMER', 'POTTER', 'RANDALL', 'ROBERTS', 'SHERMAN', 'SWISHER', 'WHEELER'],
  
  'Atlanta': ['BOWIE', 'CAMP', 'CASS', 'HARRISON', 'MARION', 'MORRIS', 'PANOLA', 'TITUS', 'UPSHUR'],
  
  'Austin': ['BASTROP', 'BLANCO', 'BURNET', 'CALDWELL', 'FAYETTE', 'HAYS', 'LEE', 'LLANO', 'SAN SABA', 'TRAVIS', 'WILLIAMSON'],
  
  'Beaumont': ['HARDIN', 'JASPER', 'JEFFERSON', 'NEWTON', 'ORANGE', 'TYLER'],
  
  'Brownwood': ['BROWN', 'COLEMAN', 'COMANCHE', 'CONCHO', 'EASTLAND', 'MCCULLOCH', 'MILLS', 'RUNNELS', 'SAN SABA'],
  
  'Bryan': ['BRAZOS', 'BURLESON', 'GRIMES', 'LEON', 'MADISON', 'ROBERTSON', 'WASHINGTON'],
  
  'Childress': ['BAILEY', 'COCHRAN', 'COTTLE', 'CROSBY', 'DICKENS', 'FLOYD', 'FOARD', 'HALE', 'HARDEMAN', 'HOCKLEY', 'KING', 'LAMB', 'LUBBOCK', 'LYNN', 'MOTLEY', 'TERRY', 'WILBARGER', 'YOAKUM'],
  
  'Corpus Christi': ['ARANSAS', 'BEE', 'BROOKS', 'DUVAL', 'JIM WELLS', 'KENEDY', 'KLEBERG', 'LIVE OAK', 'NUECES', 'REFUGIO', 'SAN PATRICIO'],
  
  'Dallas': ['COLLIN', 'DALLAS', 'DENTON', 'ELLIS', 'HUNT', 'KAUFMAN', 'NAVARRO', 'ROCKWALL'],
  
  'El Paso': ['CULBERSON', 'EL PASO', 'HUDSPETH'],
  
  'Fort Worth': ['HOOD', 'JOHNSON', 'PARKER', 'SOMERVELL', 'TARRANT', 'WISE'],
  
  'Houston': ['AUSTIN', 'COLORADO', 'FORT BEND', 'HARRIS', 'LIBERTY', 'MONTGOMERY', 'WALKER', 'WALLER', 'WHARTON'],
  
  'Laredo': ['DIMMIT', 'JIM HOGG', 'LA SALLE', 'MCMULLEN', 'WEBB', 'ZAPATA'],
  
  'Lubbock': ['ANDREWS', 'BORDEN', 'DAWSON', 'GAINES', 'GARZA', 'HOWARD', 'MARTIN', 'MIDLAND', 'SCURRY'],
  
  'Lufkin': ['ANGELINA', 'HOUSTON', 'NACOGDOCHES', 'POLK', 'SABINE', 'SAN AUGUSTINE', 'SHELBY', 'TRINITY'],
  
  'Odessa': ['CRANE', 'CROCKETT', 'ECTOR', 'GLASSCOCK', 'IRION', 'LOVING', 'PECOS', 'REAGAN', 'TERRELL', 'UPTON', 'WARD', 'WINKLER'],
  
  'Paris': ['COLLIN', 'DELTA', 'FANNIN', 'GRAYSON', 'HOPKINS', 'HUNT', 'LAMAR', 'RAINS', 'RED RIVER'],
  
  'Pharr': ['CAMERON', 'HIDALGO', 'WILLACY'],
  
  'San Angelo': ['COKE', 'KIMBLE', 'MASON', 'MENARD', 'SCHLEICHER', 'STERLING', 'SUTTON', 'TOM GREEN'],
  
  'San Antonio': ['ATASCOSA', 'BANDERA', 'BEXAR', 'COMAL', 'FRIO', 'GILLESPIE', 'GUADALUPE', 'KARNES', 'KENDALL', 'KERR', 'MEDINA', 'REAL', 'UVALDE', 'WILSON'],
  
  'Tyler': ['ANDERSON', 'CHEROKEE', 'GREGG', 'HENDERSON', 'RUSK', 'SMITH', 'VAN ZANDT', 'WOOD'],
  
  'Waco': ['BELL', 'BOSQUE', 'CORYELL', 'FALLS', 'FREESTONE', 'HAMILTON', 'HILL', 'LIMESTONE', 'MCLENNAN', 'MILAM'],
  
  'Wichita Falls': ['ARCHER', 'BAYLOR', 'CLAY', 'JACK', 'MONTAGUE', 'WICHITA', 'YOUNG'],
  
  'Yoakum': ['CALHOUN', 'DE WITT', 'GOLIAD', 'GONZALES', 'JACKSON', 'LAVACA', 'MATAGORDA', 'VICTORIA']
};

// Reverse mapping: County -> District
export const getDistrictByCounty = (county) => {
  if (!county) return null;
  
  const upperCounty = county.toUpperCase().trim();
  
  for (const [district, counties] of Object.entries(TXDOT_DISTRICTS)) {
    if (counties.includes(upperCounty)) {
      return district;
    }
  }
  
  return 'Unknown';
};

// Get all district names
export const getAllDistricts = () => {
  return Object.keys(TXDOT_DISTRICTS).sort();
};

// Get counties in a specific district
export const getCountiesInDistrict = (district) => {
  return TXDOT_DISTRICTS[district] || [];
};

// Get district statistics from bids/projects
export const getDistrictStats = (items) => {
  const stats = {};
  
  items.forEach(item => {
    const county = item.project_info?.county || item.county;
    const district = getDistrictByCounty(county);
    
    if (district && district !== 'Unknown') {
      if (!stats[district]) {
        stats[district] = {
          count: 0,
          totalValue: 0
        };
      }
      stats[district].count++;
      stats[district].totalValue += item.final_total || item.bid_amount || 0;
    }
  });
  
  return stats;
};
